angular.module('wco.directives.draggableAvailableItem', [])
.controller('WcoDraggableAvailableItemController', ['$scope', '$attrs', '$interpolate', '$timeout', function($scope, $attrs, $interpolate, $timeout) {
    $scope.clickedItem = function(item){
        $scope.$emit('clickedItem', item);
    }
}])
.directive('wcoDraggableAvailableItem', ['$timeout', function($timeout) {
    return {
        controller: 'WcoDraggableAvailableItemController',
        controllerAs: 'draggableAvailableItem',
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || 'angular/directives/draggableAvailableItem.html';
        },
        transclude: true,
        replace: true,
        scope:{
            item: '='
        },
        priority: 999,
        link: function(scope, element, attrs) {
            $timeout(function() {
                $(element).draggable({
                    appendTo: 'body',
                    helper: function(e){
                        let tr = $(e.currentTarget);
                        var $originals = tr.children();
                        var $helper = tr.clone();
                        $helper.children().each(function(index)
                        {
                            // Set helper cell sizes to match the original sizes
                            $(this).width($originals.eq(index).width());
                        });
                        return $helper;
                    },
                    revert: 'invalid',
                    distance: 20,
                    start: function(event, ui){
                        if ($(event.target).hasClass('fully-packed') ||
                            $(event.target).hasClass('item-from-other-slip')){
                            return false;
                        }

                        $(event.target).addClass('item-beeing-dragged');
                    },
                    stop: function(event, ui){
                        $(event.target).removeClass('item-beeing-dragged');
                    }
                });
            });
        }
    };
}]);